<div class="auth-container p-2">
  <div class="login-box">
    <div class="surface-card p-4 shadow-2 border-round-2xl w-full">

      <div class="flex justify-content-center">
        <div class="text-center mb-5 mt-3">
          <img src="../../../../assets/images/logo_klaus_light_blue.svg"
               class="w-10rem" alt="logo" (click)="navigateToLogin()">
        </div>
      </div>

      <div class="text-center mb-4">
        <div class="text-color text-3xl font-semibold mb-2">Login mit Einmalpasswort</div>
        <span class="text-600 font-medium line-height-3 text-color-secondary">Wähle, wie du dein Einmalpasswort erhalten möchtest.</span>
      </div>

      <div class="mb-3 flex flex-column gap-3">
        <div *ngFor="let option of otpOptions"
             class="flex align-items-center p-3 border-1 border-200 border-round"
             [class.bg-primary-50]="option.type === selectedOption">
          <p-radioButton
            [(ngModel)]="selectedOption"
            [name]="'deliveryMethod'"
            [value]="option.type"
            [inputId]="option.type.toString()"
          ></p-radioButton>
          <label class="ml-2 cursor-pointer" [for]="option.type">
            {{ option.label }}
          </label>
        </div>
      </div>
      <app-button
        [type]="'submit'"
        [busy]="busy"
        [label]="'Weiter'"
        [class]="'w-full my-2'"
        (click)="handleStepComplete(selectedOption)">
      </app-button>

      <div class="flex justify-content-center">
        <app-button
          [label]="'Zurück Aur Anmeldung'"
          [class]="'p-button-text mt-2'"
          [showIcon]="true"
          [iconPos]="'left'"
          [icon]="'pi pi-arrow-left'"
          (onClick)="navigateBack()">
        </app-button>
      </div>

    </div>
  </div>
</div>
